import React, { useState } from 'react';
import Modal from 'react-modal';
import Theme from '../../Theme';
import XIcon from '../../SVG/XIcon';
import StyledModal from './styles';

if (process.env.NODE_ENV !== 'test') Modal.setAppElement('#___gatsby');

const { colorGrayBlue50 } = Theme.color;
const { scaleUp02 } = Theme.scale;

const titleRef = React.createRef();
let overlayRef;
/**
 *
 * HOC that wraps React Modal.
 * API, remains the same with one exception.
 * A method to close the modal passed as a "close" prop is required.
 */
const SendGridModal = ({
  title,
  stickyContent,
  hasStickyHeader,
  children,
  ...props
}) => {
  const [isStuck, setStuck] = useState(false);
  const stickyTitle = () => {
    setStuck(titleRef.current.offsetTop === overlayRef.scrollTop);
  };

  const modalTitleClasses = ['modal-title'];
  if (hasStickyHeader) modalTitleClasses.push('is-sticky');
  if (isStuck) modalTitleClasses.push('is-stuck');

  return (
    <StyledModal
      {...props}
      onRequestClose={() => {
        props.close(false);
        if (hasStickyHeader) {
          overlayRef.removeEventListener('scroll', stickyTitle);
          setStuck(false);
        }
      }}
      onAfterOpen={() => {
        if (hasStickyHeader) {
          overlayRef.addEventListener('scroll', stickyTitle);
        }
      }}
      overlayRef={(node) => {
        overlayRef = node;
      }}
    >
      <div>
        <div ref={titleRef} className={modalTitleClasses.join(' ')}>
          <div className="modal-controls">
            {title && <h3>{title}</h3>}
            <button type="button" onClick={() => props.close(false)}>
              <XIcon size={scaleUp02} color={colorGrayBlue50} />
            </button>
          </div>
          {stickyContent}
        </div>
        {children}
      </div>
    </StyledModal>
  );
};
export default SendGridModal;
